// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"0bc800f6","453":"7480b7ea","455":"28d352ee"}[chunkId] + ".chunk.js";
};